<template>
  <tr>
    <td>{{ logItem.user_id }}</td>
    <td>
      {{ entity }}
    </td>
    <td :class="spanClass">{{ method }}</td>
    <td>
      <pre class="logging" style="max-height: 150px; max-width: 360px; font-size: 14px;">{{
        valueAfterChange
      }}</pre>
    </td>
    <td>
      <pre class="logging" style="max-height: 150px; max-width: 360px; font-size: 14px;">{{
        valueBeforeChange
      }}</pre>
    </td>
    <td v-html="dateString"></td>
    <td></td>
  </tr>
</template>

<script>
import { DATE_FORMAT } from '@/main.config.js'
import { trainingDate } from '@/mixins/training-date.js'
import('@/styles/components/logging.less')

export default {
  name: 'LoggingTableRow',
  mixins: [trainingDate],
  props: {
    logItem: {
      type: Object,
      required: true
    }
  },
  computed: {
    entity() {
      let formatEntityId = this.logItem.entity_id.replace(/,/g, ', ')
      return `${this.logItem.entity_name}/${formatEntityId}`
    },
    method() {
      return this.logItem.action
    },
    valueAfterChange() {
      return JSON.stringify(JSON.parse(this.logItem.action_data), undefined, 2)
    },
    valueBeforeChange() {
      return JSON.stringify(JSON.parse(this.logItem.old_data), undefined, 2)
    },
    color() {
      switch (this.logItem.action) {
        case 'patch':
          return 'secondary'
        case 'create':
          return 'success'
        case 'remove':
          return 'danger'
        default:
          return 'secondary'
      }
    },
    spanClass() {
      return `initialism text-${this.color}`
    },
    dateString() {
      let momentDate = this.moment.utc(this.logItem.createdAt, DATE_FORMAT.serverFull).local()
      let date = momentDate.format(DATE_FORMAT[`${this.$store.getters.LOCALE}`])
      date += '<br/><small>' + momentDate.format(DATE_FORMAT.timeHMS) + '</small>'
      return date
    }
  },
  methods: {}
}
</script>
